module.exports = __webpack_public_path__ + "static/media/bullet.bcf3e4f9.svg";